import { render } from "./SignAndSubmitModal.vue?vue&type=template&id=f9d3e1bc&ts=true"
import script from "./SignAndSubmitModal.vue?vue&type=script&lang=ts"
export * from "./SignAndSubmitModal.vue?vue&type=script&lang=ts"

import "./SignAndSubmitModal.vue?vue&type=style&index=0&id=f9d3e1bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__